import React, { useRef, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";
import { AssetStore } from "../../../../assets/AssetsStore";
import styles from "./index.module.scss";
import Lottie from "lottie-react";
import CustomModal from "../../../Modals/Reusable Modals/CustomModal/CustomModal";
import useWindowDimensions from "../../../../Helpers/Hooks/useWindowDimensions";
import FileViewModal from "../../../Modals/FileViewModal/FileViewModal";
import AcceptModal from "../../../Modals/AcceptRejectModal";
import RejectModal from "../../../Modals/AcceptRejectModal/RejectModal";
import { Tooltip } from "antd";
import moment from "moment";

import { useDispatch } from "react-redux";
import { findConsultationForNow } from "../../../../actions/DashboardActions";
import {
  fetch_doctor_today_appointment,
  fetch_doctor_appointment_requests,
  fetch_doctor_patientList,
} from "../../../../actions/DoctorDashboardAction";

import { getFileTypeFromFileName } from "../../../../Helpers/FileHelper";
import DashboardCard from "../../../Cards/DashboardCard/DashboardCard";
import { DashboardIcons } from "../../../../assets/dashboardv2/DsahboardIcons";
import {
  RpmStatusTriangle,
  CompletedGreen,
} from "../../../../assets/Logos/Icons";
import PatientRpmComponent from "../PatientRpmComponent/Index";

function DoctorDashboardComponent({ goToHistory }) {
  const [tabHeaders] = useState([
    {
      name: "Consultation Today",
      isOnline: true,
      date: moment().format("DD-MMM-YYYY"),
    },
  ]);

  const { width } = useWindowDimensions();

  // const appointmentId = "1234567"
  const currentDate = moment().format("DD-MMM-YYYY");

  // const handleBookcardClick = () => {
  //   history.push("/");
  // };

  const bottomCards = [
    {
      variant: "v1",
      icon: DashboardIcons.BookIcon(),
      title: "My Appointments",
      handleClick: goToHistory,
    },
    {
      variant: "v2",
      icon: DashboardIcons.playstore(),
      title: "Download Android App",
      handleClick: () => {
        window.open(
          "https://play.google.com/store/apps/details?id=com.neevlabs.connect2mydoctordoctor&hl=en",
          "_blank" // <- This is what makes it open in a new window.
        );
      },
    },
    {
      variant: "v3",
      icon: DashboardIcons.appstore(),
      title: "Download iOS App",
      handleClick: () => {
        window.open(
          "https://apps.apple.com/au/app/connect2mydoctor-for-doctor/id1490637875",
          "_blank" // <- This is what makes it open in a new window.
        );
        //  window.location.href="https://apps.apple.com/au/app/connect2mydoctor-for-doctor/id1490637875"
      },
    },
    /* {
      variant: "v4",
      icon: DashboardIcons.YoutubeIcon(),
      title: "Our Youtube channel",
      handleClick: () => {
        window.open("https://www.youtube.com/@gangahospitalcbe");
      },
    },
    {
      variant: "v5",
      icon: DashboardIcons.HeartIcon(),
      title: "Read patient Stories",
      handleClick: () => {
        window.open("https://www.gangahospital.com/patient_testimonial");
      },
    }, */
    // {
    //   variant: "v1",
    //   icon: DashboardIcons.BookIcon(),
    //   title: "Last Invitation",
    //   handleClick: () => { },
    // },
    // {
    //   variant: "v3",
    //   icon: DashboardIcons.BookIcon(),
    //   title: "More",
    //   handleClick: () => { },
    // },
  ];

  const viewTypes = {
    DASHBOARD_VIEW: "DASHBOARD_VIEW",
    PATIENT_RPM_VIEW: "PATIENT_RPM_VIEW",
  };

  //Refs................................................

  const dispatch = useDispatch();
  const history = useHistory();
  //State................................................
  const [activeHeader] = useState(() => tabHeaders[0]);
  const [activeTab, setActiveTab] = useState(0);
  const [tabContent, setTabContent] = useState([]);
  const [tabs, setTabs] = useState([]);
  const [isJoinnowEnable, setisJoinnowEnable] = useState(true);
  const [activeConsultationId, setactiveConsultationId] = useState("");
  let [acceptModal, setAcceptModal] = useState(false);
  let [reassignModal, setReassignModal] = useState(false);
  let [rejectModal, setRejectModal] = useState(false);
  let [reAssignData, setReassignData] = useState({});
  let [requestedData, setRequestedData] = useState({});
  let [processdone, setProcessdone] = useState(false);
  let [appointmentDetails, setAppointmentDetails] = useState({});

  const [isUploadHelperModal, setUploadHelperModal] = useState(false);
  const [fileViewModal, setFileVIewModal] = useState(false);
  const [isloaded, setIsloaded] = useState(false);
  const [clickedFile, setClickedFile] = useState(null);
  const [UserData, setUserData] = useState(
    JSON.parse(localStorage.getItem("userData"))
  );
  const [isloggedIn, setIsloggedIn] = useState(
    UserData != null && UserData != undefined ? true : false
  );
  const [RecentActiviites, setRecentActiviites] = useState([]);
  const [consultnow, setconsultnow] = useState([]);
  const [patientlist, setPatientlist] = useState([]);
  const [view, setView] = useState(viewTypes.DASHBOARD_VIEW);
  const toggleAcceptModal = (flag) => setAcceptModal(flag ? flag : false);
  const toggleReassignModal = (flag) => setReassignModal(flag ? flag : false);
  const toggleRejectModal = (flag) => setRejectModal(flag ? flag : false);
  const clientDetails =
    localStorage.getItem("clinicDetails") != null &&
    localStorage.getItem("clinicDetails") != undefined
      ? JSON.parse(localStorage.getItem("clinicDetails"))
      : null;
  const [AppointmentsRecentActiviites, setAppointmentsRecentActiviites] =
    useState([]);

  const [isloadedtab, setIsloadedtab] = useState(false);

  //useEffects
  let today = moment(new Date()).format("DD-MMM-YYYY");
  useEffect(() => {
    console.log("currentDate", currentDate);
    if (isloggedIn) {
      
      if (!isloaded) {
        dispatch(
          fetch_doctor_today_appointment(
            UserData.userId,
            UserData.userName,
            UserData.mobileNumber
          )
        ).then((res) => {
          console.log("recent activities", res);
          if (res) {
            setIsloaded(true);
            setAppointmentsRecentActiviites(res?.appointmentDetail);
            loadappointments(res?.appointmentDetail);
            // loadappointmentrequests(res?.data);
            checkConsultationNow();
          }
        });

        // loadpatientlist();
        //loadRecentActivitites()
      }
      const interval = setInterval(() => {
        checkConsultationNow();
      }, 15000);
      return () => clearInterval(interval);
    } else {
      history.push("/signin");
    }
    // setTabContent([...tabContent, newTabContent]);
    //settabHeaders([...tabHeaders,  { name: "Consultation Today2", isOnline: true, date: moment().format('DD-MMM-YYYY') }])
  }, [AppointmentsRecentActiviites, tabContent]);

  //Functions..............................................
  const addTab = () => {
    const newTabContent = {
      title: `Tab ${tabContent.length + 1}`,
      content: `Content for tab ${tabContent.length + 1}`,
    };
    setTabContent([...tabContent, newTabContent]);
  };

  const getNavBarStyle = () => {
    return {
      backgroundColor:
        clientDetails && clientDetails.headercolor
          ? clientDetails.headercolor
          : "#69359B",
      color: "#fff",
      borderColor:
        clientDetails && clientDetails.headercolor
          ? clientDetails.headercolor
          : "#69359B",
    };
  };

  //Recent activities fetching.
  function loadRecentActivitites() {
    //patientId, email, phone
    dispatch(fetch_doctor_appointment_requests(UserData.userId)).then((res) => {
      console.log("recent activities", res);
      if (res) {
        loadappointmentrequests(res);

        // setTabContent(newTabs);
        //   setTabContent([...tabContent, newTabs]);
      }
    });
  }
  //end region

  function loadappointmentrequests(res) {
    let newTabContents = [];

    res.map((item, index) =>
      newTabContents.push({
        icon:
          item.appointmentStatus === "Requested" ? (
            <RpmStatusTriangle variant={"Abnormal"} size="15" />
          ) : item.appointmentStatus === "Accepted by doctor" ? (
            <RpmStatusTriangle variant={"Abnormal"} size="15" />
          ) : (
            <RpmStatusTriangle variant={"Critical"} size="15" />
          ),

        name:
          item.appointmentStatus === "Requested" ? (
            <>
              <span>
                <b>Request Pending </b>: {item.patientName}
              </span>
            </>
          ) : item.appointmentStatus === "Accepted by doctor" ? (
            <>
              <span>
                <b>Request Confirmed </b>: {item.DisplayDate}
              </span>
            </>
          ) : (
            <Tooltip
              placement="top"
              title={
                <>
                  <p>Appointment Requested on </p>
                  <span>{item.appointmentDate}</span>
                </>
              }
            >
              <b>Request Rejected</b> : {item.DisplayDate}
            </Tooltip>
          ),
        id: index,
        isOnline: false,
        content: JSON.stringify(item),
      })
    );

    //   console.log("...Requests", newTabContents);
    setTabContent((prev) => {
      return [...prev, ...newTabContents];
    });
    //   // loadReports(0)
    //   // console.log("*******newTabs", newTabContents);
    //   // console.log(
    //   //   "after adding loadappointmentrequestsstart upcoming tabs",
    //   //   tabContent
    //   // ); // Check if the state is updated
    //   // console.log("*******************end*********************");
  }

  function loadappointments(res) {
    let newTabContents = [];
    // console.log("*******************start*********************");
    // console.log("befor adding tabs", tabContent);

    console.log("findUpcomingAppointment", findUpcomingAppointment(res));
    const newTabs = sort_by_key(res, "listorder").map((item, index) => ({
      //  const newTabs = res.map((item, index) => ({
      name:
        item.appointmentStatus === "P"
          ? "Consultation on " + item.appointmentDate
          : item.appointmentStatus.includes("CP") ||
            item.appointmentStatus.includes("CD")
          ? "Consultation Cancelled"
          : "Consultation Completed - (" + item.appointmentDate + ")",
      id: index,
      state: item.appointmentStatus,
      status:
        item.appointmentStatus === "CP" || item.appointmentStatus === "CD"
          ? "Cancelled"
          : item.status === "Completed"
          ? "Completed"
          : "Upcoming",
      icon:
        item.appointmentStatus === "C" ||
        item.appointmentStatus === "PD" ||
        item.status === "Completed" ? (
          <CompletedGreen size="15" />
        ) : item.appointmentStatus === "CP" ||
          item.appointmentStatus === "CD" ? (
          <RpmStatusTriangle variant={"Critical"} size="15" />
        ) : (
          <RpmStatusTriangle variant={"normal"} size="15" />
        ),

      isCompleted:
        item.status != "Upcoming" || item.status != "On-going" ? true : false,
      //date: item.status === "Upcoming" ? moment().format("DD-MMM-YYYY") : "",
      content: JSON.stringify(item),
    }));

    console.log("...Bookings", newTabs);
    setTabContent((prev) => {
      return [...prev, ...newTabs];
    });
    // loadRecentActivitites()
    // console.log("after adding upcoming tabs", tabContent); // Check if the state is updated
    // console.log("*******************end*********************");

    setIsloadedtab(true);
   // checkConsultationNow();
  }

  function loadpatientlist() {
    dispatch(fetch_doctor_patientList(UserData.userId)).then((res) => {
      console.log("recent activities", res);
      if (res) {
        setPatientlist(res);
      }
    });
  }

  //For requests................

  function sort_by_key(array, key) {
    console.log("enterd in the sort function with ", array);
    return array.sort(function (a, b) {
      var x = a[key];
      var y = b[key];
      return x < y ? -1 : x > y ? 1 : 0;
    });
  }

  function findUpcomingAppointment(res) {
    const appointments = res;
    const currentDateTime = new Date();

    let upcomingAppointment = null;
    let minTimeDifference = Infinity;

    appointments.forEach((appointment) => {
      const appointmentTimeStr = appointment.appointmentTime;
      const [startTimeStr, endTimeStr] = appointmentTimeStr.split(" - ");

      const startTime = new Date(`${currentDate} ${startTimeStr}`);
      const endTime = new Date(`${currentDate} ${endTimeStr}`);

      if (startTime > currentDateTime) {
        console.log("here*************");
        const timeDifference = startTime - currentDateTime;
        console.log("timeDifference*************", timeDifference);
        console.log("minTimeDifference*************", minTimeDifference);
        if (timeDifference < minTimeDifference) {
          minTimeDifference = timeDifference;
          upcomingAppointment = appointment;
        }
      }
    });

    return upcomingAppointment;
  }

  function checkConsultationNow() {
    dispatch(findConsultationForNow(UserData.userType, UserData.userId))
  .then((res) => {
    console.log("checkConsultationNow", res);
    if (res.appointmentId != undefined) {
      setconsultnow(res);
      if (
        res.appointmentId ===
        (tabContent[activeTab]?.content && JSON.parse(tabContent[activeTab]?.content).appointmentId)
      ) {
        setisJoinnowEnable(false);
      }
      setactiveConsultationId(res.appointmentId);
    }
  })
  .catch((err) => {
    console.error("Error fetching consultation", err);
  });
  }

  function closeUploadHelperModal() {
    setUploadHelperModal(false);
  }

  function isOverDataAvailable() {
    if (width >= 1280 && tabContent.length > 3) {
      return true;
    } else if (width < 1280 && tabContent.length > 2) {
      return true;
    }
  }

  const closeFileViewModal = () => {
    setFileVIewModal(false);
  };

  let loadConsultation = (appointmentId) => {
    if (consultnow.appointmentId === appointmentId) {
      console.log(consultnow);
      history.push("/meetdr/" + appointmentId);
    }
  };

  // let downloadInvoice = (res) => {
  //   console.log(tabContent);
  //   const newTabs = {
  //     name: "Appointment Request",
  //     id: 5,
  //     isOnline: true,
  //     date: moment().format("DD-MMM-YYYY"),
  //     content: JSON.stringify(res),
  //   };

  //   setTabContent([...tabContent, newTabs]);
  // };

  // let handleGridFileClick = (type, item, key) => {
  //   setClickedFile(item);
  //   setFileVIewModal(true);
  // };
  // let handleRemoveReportClick = (data) => {
  //   console.log(data);

  //   setReports((prev) => prev.filter((each) => each.name != data.name));
  //   // dispatch(RemoveFileFromServer(data?.file?.fileName))
  // };

  const handlePatientNameClick = (patientDetails) => {
    console.log("Patient Details", patientDetails);
    //setView(viewTypes.PATIENT_RPM_VIEW);
  };

  console.log("processdone", tabContent);

  return (
    <div className={styles.container}>
      {view === viewTypes.PATIENT_RPM_VIEW ? (
        <PatientRpmComponent />
      ) : (
        <>
          {tabContent && tabContent.length ? (
            <div className={styles.tab_wrap}>
              <div className={styles.tab_header}>
                {width >= 1399
                  ? tabContent.slice(0, 3).map((tab, index) => (
                      // <button key={index} onClick={() => setActiveTab(index)}>{tab.title}</button>
                      <div
                        onClick={() => {
                          setActiveTab(index);
                          // loadReports(index)
                          // setReports( ...reports,tabContent[activeTab]?.content?.reports!=undefined?tabContent[activeTab]?.content?.reports:"")
                        }}
                        key={index}
                        className={`${styles.tab_header_item} ${
                          activeTab === index && styles.tab_header_item_active
                        }`}
                      >
                        <div className={`${styles.status_indicator} `}>
                          {tab.icon}
                        </div>
                        <span>
                          {tab.name}&nbsp;
                          {tab.date && (
                            <div className={styles.date}>({tab.date})</div>
                          )}
                        </span>
                      </div>
                    ))
                  : tabContent.slice(0, 3).map((tab, index) => (
                      <div
                        onClick={() => {
                          setActiveTab(index);
                          // loadReports(index);
                        }}
                        key={index}
                        className={`${styles.tab_header_item} ${
                          activeTab === index && styles.tab_header_item_active
                        }`}
                      >
                        <div className={`${styles.status_indicator} `}>
                          {tab.icon}
                        </div>
                        <span>
                          {tab.name}&nbsp;
                          {tab.date && (
                            <div className={styles.date}>({tab.date})</div>
                          )}
                        </span>
                      </div>
                    ))}

                {isOverDataAvailable() ? (
                  <div className={styles.tab_header_item} onClick={goToHistory}>
                    <img
                      className={styles.action_btn}
                      src={AssetStore.dashbaodrV2.triangle}
                      alt=""
                    />
                  </div>
                ) : null}
              </div>

              {tabContent[activeTab]?.content ? (
                <div className={styles.tab_body}>
                  {activeHeader?.isCompleted ? (
                    <>
                      <div className={styles.tab_body_item}>
                        <h6>Rate this consultation - Dr John Doe</h6>

                        <div className={styles.tab_body_item_body}>
                          <div className={styles.profile_wtrap}>
                            <img
                              className={styles.avatar}
                              src={AssetStore.dashbaodrV2.user}
                              alt=""
                            />

                            <div className={styles.profile_content}>
                              {[...Array(3)].map((each, key) => {
                                return (
                                  <div
                                    key={key}
                                    className={styles.profile_content}
                                  >
                                    <div className={styles.text}>
                                      Criteria {key + 1}
                                      <div className={styles.icon}></div>
                                      <div className={styles.icon}></div>
                                      <div className={styles.icon}></div>
                                      <div className={styles.icon}></div>
                                      <div className={styles.icon}></div>
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          </div>

                          <div className={styles.tab_body_item_footer}>
                            <button>Book Now</button>
                          </div>
                        </div>
                      </div>

                      <div className={styles.tab_body_item}>
                        <h6>Follow up Appointment</h6>

                        <div className={styles.tab_body_item_body}>
                          <div className={styles.profile_wtrap}>
                            <img
                              className={styles.avatar}
                              src={AssetStore.dashbaodrV2.user}
                              alt=""
                            />

                            <div className={styles.profile_content}>
                              <div className={styles.username}>
                                {" "}
                                Dr. John Doe{" "}
                              </div>
                              <div className={styles.text}>
                                <div className={styles.icon}></div> Follow up
                                consultation recommended by Doctor in 3 weeks
                              </div>
                            </div>
                          </div>

                          <div className={styles.tab_body_item_footer}>
                            <button>Book Now</button>
                          </div>
                        </div>
                      </div>

                      <div className={styles.tab_body_item}>
                        <h6>Prescription & Invoice</h6>

                        <div className={styles.tab_body_item_body}>
                          <div className={styles.profile_wtrap}>
                            <div className={styles.profile_content}>
                              <div className={styles.profile_content}>
                                <div className={styles.text}>
                                  <div className={styles.big_icon}>
                                    <img
                                      src={AssetStore.dashbaodrV2.prescription}
                                      alt=""
                                    />
                                  </div>
                                  <Link>Download Prescription</Link>
                                </div>

                                <div className={styles.text}>
                                  <div className={styles.big_icon}>
                                    <img
                                      src={AssetStore.dashbaodrV2.prescription}
                                      alt=""
                                    />
                                  </div>
                                  <Link>Download Invoice</Link>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  ) : (
                    <>
                      {tabContent[activeTab]?.content ? (
                        <>
                          <div className={styles.tab_body_item}>
                            <h6>Appointment Details</h6>

                            <div className={styles.tab_body_item_body}>
                              <div className={styles.profile_wtrap}>
                                <img
                                  className={styles.avatar}
                                  src={
                                    JSON.parse(tabContent[activeTab].content)
                                      .type === "Request"
                                      ? JSON.parse(
                                          tabContent[activeTab].content
                                        ).profileImage
                                      : JSON.parse(
                                          tabContent[activeTab].content
                                        ).patientImage !== ""
                                      ? JSON.parse(
                                          tabContent[activeTab].content
                                        ).patientImage
                                      : AssetStore.dashbaodrV2.user
                                  }
                                  alt=""
                                />

                                <div className={styles.profile_content}>
                                  <div
                                    onClick={() => {
                                      handlePatientNameClick(
                                        JSON.parse(
                                          tabContent[activeTab].content
                                        )
                                      );
                                    }}
                                    className={styles.username}
                                  >
                                    {" "}
                                    {
                                      JSON.parse(tabContent[activeTab].content)
                                        .patientName
                                    }{" "}
                                  </div>
                                  {/* <div className={styles.text}>
                                <div className={styles.icon}>{DashboardIcons.BookIcon()}</div>{" "}
                                {
                                  JSON.parse(tabContent[activeTab].content)
                                    .reasonForVisit
                                }
                              </div> */}
                                  {JSON.parse(tabContent[activeTab].content)
                                    .type === "Schedule" && (
                                    <div className={styles.text}>
                                      <div className={styles.icon}>
                                        {" "}
                                        {DashboardIcons.TimeIcon()}
                                      </div>{" "}
                                      {JSON.parse(tabContent[activeTab].content)
                                        .type === "Request"
                                        ? JSON.parse(
                                            tabContent[activeTab].content
                                          ).appointmentDate
                                        : JSON.parse(
                                            tabContent[activeTab].content
                                          ).appointmentTime}
                                    </div>
                                  )}
                                  {JSON.parse(tabContent[activeTab].content)
                                    .type != "Schedule" && (
                                    <div className={styles.text}>
                                      <div className={styles.icon}>
                                        {DashboardIcons.AppointmentStatus()}
                                      </div>{" "}
                                      {
                                        JSON.parse(
                                          tabContent[activeTab].content
                                        ).appointmentStatus
                                      }
                                    </div>
                                  )}

                                  {JSON.parse(tabContent[activeTab].content)
                                    .Invoice !== undefined && (
                                    <div className={styles.text}>
                                      <div className={styles.icon}>
                                        {" "}
                                        {DashboardIcons.InvoiceIcon()}
                                      </div>{" "}
                                      <a
                                        href={
                                          JSON.parse(
                                            tabContent[activeTab].content
                                          ).Invoice !== undefined
                                            ? JSON.parse(
                                                tabContent[activeTab].content
                                              ).Invoice
                                            : ""
                                        }
                                        target="_blank"
                                      >
                                        Download Invoice
                                      </a>
                                    </div>
                                  )}
                                  {JSON.parse(tabContent[activeTab].content)
                                    .prescription !== undefined &&
                                    JSON.parse(tabContent[activeTab].content)
                                      .prescription !== "" && (
                                      <div className={styles.text}>
                                        <div className={styles.icon}>
                                          {" "}
                                          {DashboardIcons.PrescriptionIcon()}
                                        </div>{" "}
                                        <a
                                          href={
                                            JSON.parse(
                                              tabContent[activeTab].content
                                            ).prescription !== undefined
                                              ? JSON.parse(
                                                  tabContent[activeTab].content
                                                ).prescription
                                              : ""
                                          }
                                          target="_blank"
                                        >
                                          Download Prescription
                                        </a>
                                      </div>
                                    )}
                                </div>
                              </div>

                              <div className={styles.tab_body_item_footer}>
                                {JSON.parse(tabContent[activeTab].content)
                                  .appointmentStatus === "P" &&
                                JSON.parse(tabContent[activeTab].content)
                                  .status !== "Completed" ? (
                                  <>
                                    <button
                                      disabled={
                                        activeConsultationId ===
                                        JSON.parse(
                                          tabContent[activeTab].content
                                        ).appointmentId
                                          ? false
                                          : true
                                      }
                                      style={
                                        activeConsultationId ===
                                        JSON.parse(
                                          tabContent[activeTab].content
                                        ).appointmentId
                                          ? getNavBarStyle()
                                          : null
                                      }
                                      onClick={() => {
                                        loadConsultation(
                                          JSON.parse(
                                            tabContent[activeTab].content
                                          ).appointmentId
                                        );
                                      }}
                                    >
                                      Join Now
                                    </button>
                                    <span className={styles.normal_text}>
                                      Clickable 5 min before the scheduled time
                                    </span>
                                  </>
                                ) : (
                                  ""
                                )}
                              </div>
                              <div className={styles.tab_body_item_footer_btn}>
                                {JSON.parse(tabContent[activeTab].content)
                                  .type != "Schedule" &&
                                  JSON.parse(tabContent[activeTab].content)
                                    .appointmentStatus === "Requested" && (
                                    <>
                                      <div className={styles.actionbuttondiv}>
                                        <button
                                          className={styles.accept}
                                          onClick={() => {
                                            setRequestedData(
                                              JSON.parse(
                                                tabContent[activeTab].content
                                              )
                                            );
                                            toggleAcceptModal(true);
                                          }}
                                        >
                                          Accept
                                        </button>
                                      </div>

                                      <div className={styles.actionbuttondiv}>
                                        <button
                                          className={styles.reject}
                                          onClick={() => {
                                            setRequestedData(
                                              JSON.parse(
                                                tabContent[activeTab].content
                                              )
                                            );
                                            toggleRejectModal(true);
                                          }}
                                        >
                                          Reject
                                        </button>
                                      </div>
                                    </>
                                  )}
                              </div>
                            </div>
                          </div>
                          <div className={styles.tab_body_item}>
                            <h6>
                              Uploaded Reports{" "}
                              {(() => {
                                const reports =
                                  JSON.parse(tabContent[activeTab].content)
                                    .reports || [];

                                // Filter unique reports based on filename
                                const uniqueReports = [];
                                const filenames = new Set();

                                reports.forEach((report) => {
                                  if (!report.filename) {
                                    console.log(
                                      "Report with null or empty filename:",
                                      report
                                    );
                                  } else if (!filenames.has(report.filename)) {
                                    filenames.add(report.filename);
                                    uniqueReports.push(report);
                                  }
                                });

                                console.log("Unique reports:", uniqueReports);

                                // Display the count of unique reports
                                return uniqueReports.length > 0
                                  ? `(${uniqueReports.length})`
                                  : null;
                              })()}
                              
                            </h6>

                            <div className={styles.tab_body_item_body}>
                              <div className={styles.profile_wtrap}>
                                <div className={styles.profile_content}>
                                  {(() => {
                                    const reports =
                                      JSON.parse(tabContent[activeTab].content)
                                        .reports || [];

                                    // Filter unique reports based on filename
                                    const uniqueReports = [];
                                    const filenames = new Set();

                                    reports.forEach((report) => {
                                      if (!report.filename) {
                                        console.log(
                                          "Report with null or empty filename:",
                                          report
                                        );
                                      } else if (
                                        !filenames.has(report.filename)
                                      ) {
                                        filenames.add(report.filename);
                                        uniqueReports.push(report);
                                      }
                                    });

                                    console.info("Unique reports:", uniqueReports);

                                    return uniqueReports.length > 0 ? (
                                      <div className={styles.reports_wrap}>
                                        {uniqueReports.map((e, key) => (
                                          
                                          <div
                                            onClick={() => {}}
                                            key={key}
                                            className={styles.text}
                                          >
                                            <img
                                              className={styles.report_icon}
                                              src={getFileTypeFromFileName(
                                                (Array.isArray(e?.filetypes) && e?.filetypes.length > 0) 
                                                  ? e.filetypes[0] 
                                                  : (Array.isArray(e?.filename) && e?.filename.length > 0)
                                                    ? e.filename[0]
                                                    : ""
                                              )}
                                              alt=""
                                            />
                                            <a
                                              href={e.filecontent}
                                              rel="noreferrer"
                                              target="_blank"
                                            >
                                              Reports-{key + 1}
                                            </a>
                                          </div>
                                        ))}
                                      </div>
                                    ) : (
                                      <div
                                        className={
                                          styles.report_list_empty_container
                                        }
                                      >
                                        <div>
                                          <Lottie
                                            style={{ width: 80 }}
                                            animationData={
                                              AssetStore.nodataanimation
                                            }
                                            loop={true}
                                          />
                                        </div>
                                        <span
                                          className={
                                            styles.report_list_empty_container_text
                                          }
                                        >
                                          No reports
                                        </span>
                                      </div>
                                    );
                                  })()}
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className={styles.tab_body_item}>
                            <h6>Others</h6>

                            <div className={styles.tab_body_item_body}>
                              <div className={styles.profile_wtrap}>
                                <div className={styles.profile_content}>
                                  {/* <div className={styles.text}><div className={styles.icon}></div><Link>Cancel/Reschedule Appointment</Link> </div> */}
                                  <div className={styles.text}>
                                    <div className={styles.icon}>
                                      {DashboardIcons.VideoConversationIcon()}
                                    </div>{" "}
                                    {/* <a href="https://uat.c2mdr.com/ganga/img/Starting_your_Consultation.pdf" target="_blank">
                                      How to start this consultation?{" "}
                                    </a> */}
                                    <a
                                      href={`${
                                        clientDetails &&
                                        clientDetails.clinicurl != null
                                          ? clientDetails.clinicurl +
                                            "/prepareforconsultation"
                                          : "/c2md/prepareforconsultation"
                                      }`}
                                      target="_blank"
                                    >
                                      How to prepare for the consultation?{" "}
                                    </a>
                                  </div>
                                  <div className={styles.text}>
                                    <div className={styles.icon}>
                                      {" "}
                                      {DashboardIcons.PatientConsent()}
                                    </div>
                                    {JSON.parse(tabContent[activeTab].content)
                                      .Consent !== undefined ? (
                                      <a
                                        href={
                                          JSON.parse(
                                            tabContent[activeTab].content
                                          ).Consent !== undefined
                                            ? JSON.parse(
                                                tabContent[activeTab].content
                                              ).Consent
                                            : ""
                                        }
                                      >
                                        Patient Consent
                                      </a>
                                    ) : (
                                      ""
                                    )}{" "}
                                    |
                                    <a href="termsofUse/terms" target="_blank">
                                      Consultation T&C
                                    </a>
                                  </div>
                                  <div className={styles.text}>
                                    <div className={styles.icon}>
                                      {" "}
                                      {DashboardIcons.SupportIcon()}
                                    </div>{" "}
                                    Support :{" "}
                                    <a
                                      href={`mailto:${
                                        clientDetails &&
                                        clientDetails.email != null
                                          ? clientDetails.email
                                          : "support@connect2my.doctor"
                                      }`}
                                    >
                                      Email
                                    </a>
                                    |
                                    <a
                                      href={`tel:${
                                        clientDetails &&
                                        clientDetails.phoneNumber != null
                                          ? clientDetails.phoneNumber
                                          : "+91 9074170889"
                                      }`}
                                    >
                                      Call
                                    </a>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      ) : (
                        ""
                      )}
                    </>
                  )}
                </div>
              ) : (
                ""
              )}
            </div>
          ) : (
            isloadedtab && (
              <>
                <div className={styles.tab_wrap}>
                  <div className={styles.tab_header}>
                    <div
                      className={`${styles.tab_header_item} ${styles.tab_header_item_active}`}
                    >
                      <span>Consultation Today&nbsp;</span>
                    </div>
                  </div>

                  <div
                    className={styles.tab_body}
                    style={{ alignItems: "center", justifyContent: "center" }}
                  >
                    <div className={styles.noconsultation}>
                      {/* <div className={styles.icon}>
                 {DashboardIcons.BookIcon()}
                                    </div> */}
                      No Consultation today
                    </div>
                  </div>
                </div>
              </>
            )
          )}
          <div className={styles.others_grid}>
            {bottomCards.map((each, key) => (
              <DashboardCard {...each} key={key} />
            ))}
          </div>
        </>
      )}

      <CustomModal
        okText="Preview"
        caption=""
        onOk={closeUploadHelperModal}
        onClose={closeUploadHelperModal}
        isShowModal={isUploadHelperModal}
      >
        <div>Supported formats - PDF, PNG, JPEG, JPG, DOC, DOCX, DCM, ZIP.</div>
        <div>File limits - 5 files of 5MB per file</div>
      </CustomModal>

      <FileViewModal
        isShowModal={fileViewModal}
        onClose={closeFileViewModal}
        file={clickedFile}
      />
      <AcceptModal
        open={acceptModal}
        togggle={toggleAcceptModal}
        onOk={() => {}}
        appointmentData={requestedData}
        setProcessdone={setProcessdone}
      />
      <RejectModal
        open={rejectModal}
        togggle={toggleRejectModal}
        appointmentData={requestedData}
        setProcessdone={setProcessdone}
      />
    </div>
  );
}

export default DoctorDashboardComponent;
